export default __webpack_public_path__ + "static/media/curved0.7b1de374.jpg";